import { Component } from '@angular/core';

import { environment } from '@env/environment';
import { EnvironmentsEnum } from '@shared/constants/environments.constants';

@Component({
    selector: 'fc-env-ribbon',
    template: `
    @if (env === EnvironmentsEnum.develop) {
      <div class="dev env">Dev</div>
    }
    @if (env === EnvironmentsEnum.staging) {
      <div class="stage env">Staging</div>
    }
    @if (env === EnvironmentsEnum.demo) {
      <div class="demo env">Demo</div>
    }
    `,
    standalone: false
})
export class EnvRibbonComponent {
  env: string = environment.env;

  protected readonly EnvironmentsEnum = EnvironmentsEnum;
}
